import React, { useState } from 'react';
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '70%',
        padding: '20px 0',
        '& >*': {
            width: '100%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '10px 0'
        }
    }
}));

export const PhoneInput = ({ value, onComplete, ...restProps }) => {
    const classes = useStyles();
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState(false)
    const [phoneVal, setPhoneVal] = useState('')

    const onChange = (event) => {
        const regex = /^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/
        setPhoneVal(event.target.value)
        onComplete(event)
        if (regex.test(event.target.value)) {
            setError(false)
        } else {
            setError(true)
        }
    }

    const handleError = () => {
        const regex = /^[789]\d{9}$/
        if (!regex.test(phoneVal)) {
            setError(true)
            setErrorText('This is not a valid Phone Number')
        } else {
            setError(false)
            setErrorText('')
        }
    }
    return (
        <div className={classes.formControl}>
            <TextField
                label={'Mobile No'}
                name="phoneNumber"
                {...restProps}
                error={error}
                onChange={onChange}
                helperText={errorText}
                onBlur={()=> handleError()}
            />
        </div>
    )
}
